import { USER_KEY } from '../constants'

export default (): string | null => {
  const { type } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return type && type === 'retailer';
}
